var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"86061076-6584-4E66-89AD-6D8A05B2498E@1x"),React.createElement("g",{"id":"Modules","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"Intro-/-L-/-Maximal","transform":"translate(-157.000000, -669.000000)","stroke":"currentColor","strokeWidth":"5"},React.createElement("g",{"id":"Details","transform":"translate(136.000000, 331.000000)"},React.createElement("g",{"id":"Check-5","transform":"translate(24.000000, 336.000000)"},React.createElement("path",{"d":"M0,15 C1.47512521,16.4368536 3.25290299,18.4368536 5.33333333,21 C8.44444444,15 12,9.66666667 16,5","id":"Check"})))))]);
}

Check.defaultProps = {"width":"22px","height":"22px","viewBox":"0 0 22 22","version":"1.1"};

module.exports = Check;

Check.default = Check;
